export default function convertToIntArray(data: any): number[] | undefined {
  if (!data) {
    return
  }

  const stringArr: string[] = Object.values(data)

  return stringArr.map(item => parseInt(item, 10))
}
